import React, { useState } from "react";
import Modal from "../Components/Base/Modal";

export const AppConfirmSubscription = ({
  open,
  onClose,
  setModalConfirm,
  cancelsub,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => {
    setModalConfirm(null);
  };

  const handleCancelSubscription = async () => {
    setIsLoading(true);
    try {
      await cancelsub();
    } catch (error) {
      console.error("Cancellation error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      close={handleClose}
      aria-labelledby="application-details-modal"
      aria-describedby="application-details-description"
      className="!flex !items-center !justify-center p-4 "
      modelInnerClass="!max-w-[500px] !w-full"
    >
      <div
        className="bg-white rounded-xl shadow-2xl w-full  max-w-md relative  max-h-[90vh]  outline-none overflow-hidden"
      >
        {/* Header */}
        <div className="p-6 bg-gradient-to-r from-green-50 to-emerald-50">
          <button
            onClick={handleClose}
            className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
          <div className="flex items-center justify-center w-16 h-16 bg-white rounded-full mx-auto mb-4 shadow-md">
            <svg
              className="w-8 h-8 text-red-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          <h3
            className="text-2xl font-bold text-red-900 text-center"
            id="modal-title"
          >
            Cancel Subscription?
          </h3>
        </div>

        <div className="p-6">
          <p className="text-gray-600 text-center" id="modal-description">
            Are you sure you want to cancel your subscription? You'll lose
            access to premium features immediately.
          </p>
        </div>

        <div className="px-6 py-4 bg-gray-50 flex flex-col sm:flex-row justify-center space-y-3 sm:space-y-0 sm:space-x-3">
          <button
            className="px-6 py-3 text-base font-semibold text-white bg-gradient-to-r from-green-500 to-green-600 rounded-lg hover:shadow-lg hover:from-green-600 hover:to-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-all duration-200"
            onClick={handleClose}
            disabled={isLoading}
          >
            Keep Subscription
          </button>

          <button
            className={`px-6 py-3 text-base font-semibold text-white bg-gradient-to-r from-red-500 to-red-600 rounded-lg hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-all duration-200 flex items-center justify-center ${
              isLoading
                ? "opacity-75 cursor-not-allowed"
                : "hover:from-red-600 hover:to-red-700"
            }`}
            onClick={handleCancelSubscription}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <svg
                  className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                Processing...
              </>
            ) : (
              "Yes, Cancel Subscription"
            )}
          </button>
        </div>
      </div>
    </Modal>
  );
};
